/* Holo card viewer: coverflow on desktop, one-big-card swipe on phones. Transforms only; images lazy-load near the active card. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function param() { try { return new URLSearchParams(location.search).get('viewer'); } catch (e) { return null; } }

  function place(sec) {
    var want = param() || sec.getAttribute('data-default') || '1';
    if (want !== '2' || window.innerWidth < 750) return;
    var col = document.querySelector('.product__media-wrapper');
    var host = sec.closest('.shopify-section') || sec;
    if (!col) return;
    col.appendChild(host);
    sec.classList.add('hcv--side');
  }

  function init(sec) {
    if (sec.__hcv) return; sec.__hcv = true;
    if (!sec.__hcvPlaced) place(sec);
    var stage = sec.querySelector('[data-hcv-stage]');
    var slides = [].slice.call(sec.querySelectorAll('[data-hcv-slide]'));
    var prev = sec.querySelector('[data-hcv-prev]'), next = sec.querySelector('[data-hcv-next]');
    var nameEl = sec.querySelector('[data-hcv-name]'), rarEl = sec.querySelector('[data-hcv-rarity]'), iEl = sec.querySelector('[data-hcv-i]');
    var meta = sec.querySelector('.hcv__meta');
    var data = []; try { data = JSON.parse(sec.querySelector('[data-hcv-data]').textContent); } catch (e) {}
    var n = slides.length, idx = 0, pos = 0, visible = false, raf = 0;

    function mobile() { return stage.clientWidth < 600; }
    function spread() { var w = stage.clientWidth, h = stage.clientHeight * 0.92 * 5 / 7; return mobile() ? Math.min(w * 0.86, h * 1.06) : Math.max(h * 0.62, Math.min(w * 0.17, h * 0.8)); }

    // images: fetch + decode off the main thread before showing; keep a window of neighbours ready
    function load(i) {
      var s = slides[i]; if (!s) return;
      var img = s.querySelector('img[data-src]'); if (!img) return;
      var src = img.getAttribute('data-src'); img.removeAttribute('data-src');
      var ss = img.getAttribute('data-srcset'), sz = img.getAttribute('data-sizes'); /* speed Oct 12: CDN-resized widths */
      if (ss && mobile()) { var dpr = window.devicePixelRatio || 1; sz = Math.ceil(Math.max(spread(), 200) * Math.min(dpr, 2) / dpr) + 'px'; } /* SPEED2113: phones get the card's real size at up to 2x (plain CDN resize, same image) */
      var pre = new Image(); pre.decoding = 'async'; if (ss) { pre.sizes = sz || '100vw'; pre.srcset = ss; } pre.src = src;
      var show = function () { if (ss) { img.sizes = sz || '100vw'; img.srcset = ss; } img.src = src; img.classList.add('is-in'); };
      if (pre.decode) pre.decode().then(show, show); else pre.onload = show;
    }
    var nearOnce = false;
    function loadNear() { if (!visible) return; if (!nearOnce && mobile()) { nearOnce = true; load(idx); var f = slides[idx] && slides[idx].querySelector('img'), t = setTimeout(loadNear, 600); if (f) f.addEventListener('load', function () { clearTimeout(t); loadNear(); }, { once: true }); return; } for (var k = -3; k <= 4; k++) load(idx + k); } /* SPEED2113: phones fetch the front card first */

    var WIN = 4, lastVis = [];
    function render() {
      raf = 0;
      var sp = spread(), mob = mobile();
      var lo = Math.max(0, Math.floor(pos) - WIN), hi = Math.min(n - 1, Math.ceil(pos) + WIN);
      // slides leaving the window are hidden once (not touched every frame)
      for (var j = 0; j < lastVis.length; j++) { var q = lastVis[j]; if (q < lo || q > hi) slides[q].classList.remove('is-near'); }
      lastVis = [];
      for (var i = lo; i <= hi; i++) {
        var d = i - pos, a = Math.abs(d), sg = d < 0 ? -1 : 1, c = Math.min(a, 1);
        var x, z, ry, sc, op;
        if (mob) { x = d * sp; z = -c * 120; ry = -sg * c * 16; sc = 1 - c * 0.12; op = a > 1.6 ? 0 : 1 - c * 0.35; }
        else { x = sg * (c * sp + Math.max(0, a - 1) * sp * 0.55); z = -c * 260 - Math.max(0, a - 1) * 120; ry = -sg * c * 42; sc = 1 - c * 0.1; op = a > 3.6 ? 0 : 1 - Math.min(a, 3) * 0.16; }
        var s = slides[i];
        if (!s.classList.contains('is-near')) s.classList.add('is-near');
        s.style.transform = 'translate3d(calc(-50% + ' + x.toFixed(1) + 'px), -50%, ' + z.toFixed(1) + 'px) rotateY(' + ry.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        s.style.opacity = op.toFixed(3);
        s.style.setProperty('--hcv-dim', Math.min(a, 2) * 0.22);
        s.style.zIndex = String(100 - Math.round(a * 10));
        lastVis.push(i);
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(render); }

    function go(i, quiet) {
      i = Math.max(0, Math.min(n - 1, i));
      var changed = i !== idx; idx = i; pos = i;
      slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      prev.disabled = i === 0; next.disabled = i === n - 1;
      iEl.textContent = String(i + 1);
      var c = data[i] || {};
      if (changed && !quiet) { meta.classList.remove('is-swap'); void meta.offsetWidth; meta.classList.add('is-swap'); }
      nameEl.textContent = c.n || '';
      rarEl.textContent = (c.r || '') + (c.no ? ' \u00b7 ' : '');
      if (c.no) { var sp = document.createElement('span'); sp.className = 'hcv__no'; sp.textContent = c.no; rarEl.appendChild(sp); }
      loadNear(); schedule();
    }

    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(n - 1); }
    });

    // scroll wheel / trackpad: one card per notch; lets the page scroll at either end
    var wheelAcc = 0, wheelLock = 0;
    stage.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      var dir = dx > 0 ? 1 : -1;
      if ((dir < 0 && idx === 0) || (dir > 0 && idx === n - 1)) { wheelAcc = 0; return; }
      e.preventDefault();
      var now = Date.now();
      if (now < wheelLock) return;
      wheelAcc += dx;
      if (Math.abs(wheelAcc) > 30) { go(idx + dir); wheelAcc = 0; wheelLock = now + 170; }
    }, { passive: false });

    // drag / swipe
    var down = false, sx = 0, sy = 0, startPos = 0, lastX = 0, lastT = 0, vel = 0, axis = '', moved = false, pid = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('.hcv__arrow')) return;
      down = true; moved = false; axis = ''; sx = lastX = e.clientX; sy = e.clientY; lastT = performance.now(); vel = 0; startPos = pos; pid = e.pointerId;
    });
    stage.addEventListener('pointermove', function (e) {
      e.stopPropagation();
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!axis) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; if (axis === 'x') { stage.classList.add('is-drag'); try { stage.setPointerCapture(pid); } catch (er) {} } }
      if (axis !== 'x') { down = false; return; }
      moved = true;
      var t = performance.now(); vel = (e.clientX - lastX) / Math.max(1, t - lastT); lastX = e.clientX; lastT = t;
      var p = startPos - dx / spread();
      if (p < 0) p = p * 0.3; if (p > n - 1) p = n - 1 + (p - n + 1) * 0.3;
      pos = p; schedule();
      var act = slides[idx] && slides[idx].querySelector('.holo-ccard__tilt');
      if (act) act.style.setProperty('--cc-sx', Math.max(-60, Math.min(60, dx / 4)).toFixed(1) + '%');
    });
    function end(e) {
      if (!down) return; down = false; stage.classList.remove('is-drag');
      if (!moved) return;
      var target = Math.round(pos - vel * 1.1);
      target = Math.max(idx - 2, Math.min(idx + 2, target));
      go(target);
    }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); moved = false; return; }
      var s = e.target.closest('[data-hcv-slide]'); if (!s) return;
      var k = slides.indexOf(s); if (k !== idx) go(k);
    });

    // holo shimmer + tilt on the front card (mouse/pen), like the Bounty Packs chase card
    if (!reduced) {
      var maxT = 9, traf = 0;
      stage.addEventListener('pointermove', function (e) {
        if (down || (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen')) return;
        var s = slides[idx]; if (!s) return;
        var r = s.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        var tilt = s.querySelector('.holo-ccard__tilt');
        if (Math.abs(px) > 0.75 || Math.abs(py) > 0.75) return;
        cancelAnimationFrame(traf);
        traf = requestAnimationFrame(function () {
          tilt.style.setProperty('--cc-ry', (px * maxT * 2).toFixed(2) + 'deg');
          tilt.style.setProperty('--cc-rx', (-py * maxT * 2).toFixed(2) + 'deg');
          tilt.style.setProperty('--cc-sx', (px * 60).toFixed(1) + '%');
          tilt.style.setProperty('--cc-s', '1.03');
        });
      });
      stage.addEventListener('pointerleave', function () {
        slides.forEach(function (s) { var t = s.querySelector('.holo-ccard__tilt'); ['--cc-ry', '--cc-rx', '--cc-sx', '--cc-s'].forEach(function (p) { t.style.removeProperty(p); }); });
      });
      // phones: tilt with the device where the browser allows it without a prompt
      if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function' && window.matchMedia('(hover: none)').matches) {
        var graf = 0;
        window.addEventListener('deviceorientation', function (e) {
          if (!visible || e.gamma == null) return;
          cancelAnimationFrame(graf);
          graf = requestAnimationFrame(function () {
            var g = Math.max(-25, Math.min(25, e.gamma)) / 25, b = Math.max(-25, Math.min(25, (e.beta || 45) - 45)) / 25;
            var t = slides[idx] && slides[idx].querySelector('.holo-ccard__tilt'); if (!t) return;
            t.style.setProperty('--cc-ry', (g * 8).toFixed(2) + 'deg'); t.style.setProperty('--cc-rx', (-b * 8).toFixed(2) + 'deg'); t.style.setProperty('--cc-sx', (g * 50).toFixed(1) + '%');
          });
        }, { passive: true });
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { visible = en.isIntersecting; if (visible) loadNear(); sec.classList.toggle('is-off', !visible); }); }, { rootMargin: (window.matchMedia && matchMedia('(max-width: 749px)').matches) ? '2500px 0px' : '600px 0px' }).observe(sec);
    } else { visible = true; }
    window.addEventListener('resize', schedule, { passive: true });
    go(0, true);
  }

  /* Oct 14: placement runs at once (no layout jump); the viewer itself starts when it comes within ~1.5 screens of view */
  function boot() {
    [].forEach.call(document.querySelectorAll('[data-hcv]'), function (sec) {
      if (sec.__hcv || sec.__hcvWait) return;
      if (!('IntersectionObserver' in window)) { init(sec); return; }
      sec.__hcvWait = true; place(sec); sec.__hcvPlaced = true;
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); init(sec); } }, { rootMargin: (window.matchMedia && matchMedia('(max-width: 749px)').matches) ? '500px 0px' : '1200px 0px' }); /* SPEED2113: phones start the viewer just before it scrolls into view, not during page load */
      io.observe(sec);
      /* SPEED2113: phones also start it on the visitor's first scroll/touch, so the cards are ready long before they reach the viewer, but never during page load */
      if (window.matchMedia && matchMedia('(max-width: 749px)').matches) { var first = function () { ['scroll', 'touchstart', 'pointerdown'].forEach(function (t) { removeEventListener(t, first); }); io.disconnect(); init(sec); }; ['scroll', 'touchstart', 'pointerdown'].forEach(function (t) { addEventListener(t, first, { passive: true }); }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Holo Oct 12 2026: hide floating cart bubble while the card viewer is on screen at narrow widths (CSS in holo-cv.css, max-width 360px). */
(function(){var v=document.querySelectorAll('[data-hcv]');if(!v.length||!('IntersectionObserver' in window))return;var on=new Set(),h=document.documentElement;var io=new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?on.add(e.target):on.delete(e.target)});h.classList.toggle('hcv-onscreen',on.size>0)},{threshold:0});v.forEach(function(el){io.observe(el)})})();

/* Holo Oct 12 2026 (mobile only <=749px): viewer sat ~1.8 screens below the fold after the buy box; add a tappable "Flip Through The Hits" chip right under the gallery (top of product info) that jumps to it, and preload the first cards immediately. Desktop untouched. */
(function(){if(!window.matchMedia||!matchMedia('(max-width: 749px)').matches)return;function go(){var s=document.querySelector('[data-hcv]');if(!s||document.querySelector('.hcv-jump'))return;var n=s.querySelectorAll('.hcv__slide').length;
var pl=false;function pre(){if(pl)return;pl=true;['scroll','touchstart','pointerdown'].forEach(function(t){removeEventListener(t,pre)});var im=s.querySelectorAll('img[data-src]'),dpr=window.devicePixelRatio||1,st=s.querySelector('[data-hcv-stage]'),cw=Math.max(Math.min(st.clientWidth*0.86,st.clientHeight*0.92*5/7*1.06),200);for(var i=0;i<Math.min(2,im.length);i++){var l=document.createElement('link');l.rel='preload';l.as='image';l.href=im[i].getAttribute('data-src');if(im[i].getAttribute('data-srcset')){l.setAttribute('imagesrcset',im[i].getAttribute('data-srcset'));l.setAttribute('imagesizes',Math.ceil(cw*Math.min(dpr,2)/dpr)+'px');}l.setAttribute('fetchpriority',i?'low':'high');document.head.appendChild(l);}}['scroll','touchstart','pointerdown'].forEach(function(t){addEventListener(t,pre,{passive:true,once:true})}); /* SPEED2113 */
var host=document.querySelector('.product__info-container');if(!host)return;
var a=document.createElement('a');a.href='#';a.className='hcv-jump';a.innerHTML='<span class="hcv-jump__spark">\u2726</span> Flip Through The Hits'+(n?' <span class="hcv-jump__n">'+n+' cards</span>':'')+' <span class="hcv-jump__arr">\u2193</span>';
a.addEventListener('click',function(e){e.preventDefault();pre();var y=s.getBoundingClientRect().top+scrollY-12;scrollTo({top:y,behavior:'smooth'});});host.insertAdjacentElement('afterbegin',a);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();})();
